'use client';

// 이 모듈이 클라이언트 측에서 실행된다는 것을 나타냅니다.

import {
  setCookieAdfrom,
  setCookieChannelId,
  setCookieRwcode,
  setCookieZvzo,
} from '@wconcept/wconcept-common/utils/cookie';
import { getCookie } from 'cookies-next';
import { isEmpty } from 'lodash-es';
import { useEffect } from 'react';
import qs from 'qs';

/** 유튜브쇼핑 예외처리 대상 channel_id */
const YOUTUBE_SHOPPING_CHANNEL_ID = 'YT7_00001';

/** 유튜브쇼핑 인입 예외처리 adfrom prefix 목록 (소문자로 통일) */
const EXCLUDED_ADFROM_PREFIXES = [
  'baro_',
  'ap5_',
  'app_',
  'ft5_',
  'at5_',
] as const;

/** adfrom이 제외 대상 prefix로 시작하는지 확인 (대소문자 구분 없음) */
export const isExcludedAdfrom = (adfrom: string): boolean =>
  EXCLUDED_ADFROM_PREFIXES.some(prefix =>
    adfrom.toLowerCase().startsWith(prefix)
  );

function AdFromComponent() {
  useEffect(() => {
    // window 객체가 없는 서버 측에서 실행되는 것을 방지합니다.
    if (typeof window === 'undefined') return;

    // 쿼리 문자열을 가져오고 앞의 '?'를 제거합니다.
    const queryString = window.location.search.substring(1);
    // qs 라이브러리를 사용하여 쿼리 문자열을 객체로 파싱합니다.
    const queryParams = qs.parse(queryString);

    // 파라미터 키 trim + 소문자 변환 (예: `& utm_medium` 공백 방어)
    const params: { [key: string]: string } = {};
    Object.keys(queryParams).forEach(key => {
      const normalizedKey = key.trim().toLowerCase();
      if (!normalizedKey || params[normalizedKey]) {
        return;
      }

      const value = queryParams[key];
      // 값이 배열인지 확인하고, 첫 번째 값을 문자열로 저장합니다.
      if (Array.isArray(value)) {
        params[normalizedKey] = String(value[0] ?? '').trim();
      } else if (value != null) {
        params[normalizedKey] = String(value).trim();
      }
    });

    // 'adfrom' 및 'nv_ad' 파라미터 값을 가져옵니다.
    const adfrom = params.adfrom || '';
    const nvAd = params.nv_ad || '';

    // 'adfrom' 값이 비어있지 않은 경우 처리합니다.
    if (!isEmpty(adfrom)) {
      // ZVZO 관련 쿠키 세팅 (adfrom=ZV7_00001 일 때)
      if (adfrom === 'ZV7_00001') {
        setCookieZvzo({
          utm_content: params.utm_content,
          utm_medium: params.utm_medium,
          utm_source: params.utm_source,
        });
      }

      // 'adfrom'이 'naver_ep'이고 'nvAd'가 'pla'인 경우 쿠키를 'nv_ad'로 설정합니다.
      if (adfrom === 'naver_ep' && nvAd === 'pla') {
        setCookieAdfrom('nv_ad');
        setCookieChannelId('nv_ad');
        return;
      }

      const currentChannelId = (getCookie('channel_id') as string) || '';
      const isYoutubeShoppingChannel =
        currentChannelId === YOUTUBE_SHOPPING_CHANNEL_ID;

      if (isYoutubeShoppingChannel && isExcludedAdfrom(adfrom)) {
        setCookieAdfrom(adfrom);
        return;
      }

      setCookieAdfrom(adfrom);
      setCookieChannelId(adfrom);
    }

    // 수익쉐어 관련 쿠키 설정
    const rwCode = params.rwcode || '';
    if (!isEmpty(rwCode)) {
      setCookieRwcode(rwCode);
    }
  }, []);
  return null;
}

export default AdFromComponent;
